// ----------------------------------------------------------------------------
// Section: FAQs
// ----------------------------------------------------------------------------
//
// FAQs Section
// - Based on the Accordion pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';

// Styles
import './_faqs.scss';
